import React, { useState } from 'react';
import { MdOutlineTextSnippet } from 'react-icons/md';
import { BsPlusLg } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import { useNavigate } from 'react-router-dom';

const MthEndTAndC = () => {
    const [isActive, setIsActive] = useState(false);
    const navigate = useNavigate();

    // Show the temporary Terms & Conditions until 1st September 2026 (IST).
    // From 1st Sep onwards it auto-reverts to the original T&C without a new release.
    const showNewTerms = new Date() < new Date('2026-09-01T00:00:00+05:30');

    return (
        <div>
            <div className='tAndcContainer'>
                <div className="accordion-title d-flex justify-content-between align-items-center" onClick={() => setIsActive(!isActive)}>
                        <div className='faq-container'>
                            <div className='terms-icon-container'>
                                <MdOutlineTextSnippet className='terms-icon' size={20} color="#FFFFFF" style={{opacity: '0.5'}}/>
                            </div>
                            <span className='termsTitle' style={{color: '#FFFFFF'}}>Terms & Conditions</span>
                        </div>
                    <div className="col-1 d-flex justify-content-end"><span className="row toggleBtn">{isActive ? <CgClose color="#FFFFFF" size={20} /> : <BsPlusLg color="#FFFFFF" size={20} />}</span></div>
                </div>
                {isActive && <div className="accordion-content subText">
                    <div>
                        {showNewTerms ? (
                            <ul className='termAndConditionPoints mt-4' style={{color: '#FFFFFF'}}>
                                <li><p>All users earn 5% rewards on every eligible card transaction spend above Rs 200. The entire 5% can be redeemed within the GoSats app, and out of this, 1% can also be withdrawn to an external wallet.</p></li>
                                <li>
                                    <p>Rewards redemption:<br />
                                    Up to 90% of your rewards can be redeemed on vouchers.<br />
                                    Up to 10% can be redeemed on BBPS and PhonePe vouchers.<br />
                                    Paid card users will get up to Rs 10,000, while non-paid card users will get up to Rs 1,000.</p>
                                </li>
                                <li>
                                    <p>SuperCoins redemption:<br />
                                    100% can be redeemed on a physical card purchase.<br />
                                    100% can be redeemed against credit card (CC) surcharge.<br />
                                    50% can be redeemed on vouchers and BBPS.<br />
                                    10% can be redeemed on Amazon Pay, PhonePe and one-time Gold purchases.<br />
                                    1% can be redeemed against credit card (CC) repayment.</p>
                                </li>
                                <li><p>SuperCoins cannot be redeemed for any Amazon vouchers, across all Amazon categories.</p></li>
                                <li><p>Up to 10,000 SuperCoins can be redeemed this month in each category - Vouchers, BBPS and Gold investments.</p></li>
                                <li><p>Increase your monthly limit from Rs 10,000 to Rs 2,00,000 by completing your Video KYC (VKYC) for free.</p></li>
                                <li><p>The physical card is available directly at Rs 399 + GST as a one-time issuance fee.</p></li>
                                <li><p>Paid users enjoy a credit card load limit of Rs 10,000, beyond which a convenience fee is applicable.</p></li>
                                <li><p>Sats withdrawal is enabled only for users who are both paid and VKYC-verified.</p></li>
                                <li><p>The 5% rewards are not applicable on certain restricted categories, including Fastag Recharge, Indian Railways, Travel Agencies, Tour Operators, Bill/Utility Payments, Digital Wallet Loads, Real Estate, Government Services, Telecommunications, Gift/Novelty/Souvenir Shops, Insurance, Quasi Cash, Fuel, Rent/Education, Toll/Bridge, Discount Stores, and card spends on Voucher Purchases, SatsPay, BBPS and Gold Investments.</p></li>
                                <li>
                                    <p>The 5% rewards are not applicable on certain restricted merchants:<br />
                                    WWW AMAZON IN 1243054000 (all other Amazon merchants are eligible for 5% rewards)<br />
                                    Pop Tech<br />
                                    MagicPin</p>
                                </li>
                                <li><p>GoSats reserves the right to change the reward structure from time to time.</p></li>
                            </ul>
                        ) : (
                            <ul className='termAndConditionPoints mt-4'>
                                {/* <li style={{color: '#FFFFFF'}}>
                                    <p>DURATION OF THE CONTEST<br />
                                    The Contest Period shall be from 22nd January, 2026 at 10:30AM to 28th January, 2026 11:59PM.<a style={{ color: '#D1964A' }} onClick={() => { navigate('/monthBonanzaTnC') }} className='tAndc'>read more.</a></p>
                                </li> */}
                                <li style={{color: '#FFFFFF'}}>
                                    <p>ELIGIBILITY<br />
                                    To participate in the Contest, you must fulfil the following <a style={{ color: '#D1964A' }} onClick={() => { navigate('/monthBonanzaTnC') }} className='tAndc'>read more.</a></p>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>}
            </div>
        </div>
    );
}

export default MthEndTAndC;
